exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customButtonClass{background:#fff;border:1px solid #706b6b;color:#706b6b;font-size:.9vw;border-radius:4px;padding:.37vw .9vw;margin:0px 0px 0px 10px;box-shadow:0 5px 10px rgba(0,0,0,.1)}.customRedButtonClass{background:#fff;border:1px solid red;color:red;font-size:.9vw;border-radius:5px;padding:.4vw .9vw;margin:0px 0px 0px 10px;box-shadow:0 5px 10px rgba(0,0,0,.1)}", ""]);

// exports
